/* ============
 * Home Index Page
 * ============
 *
 * The home index page
 */

import store from '@/store';
import userService from '@/services/user';
import Vue from 'vue';

export default {
  components: {
    VLayout: require('@/layouts/default/default.vue'),
    VPanel: require('@/components/panel/panel.vue'),
  },
  mounted() {
    this.fetchPage();
    this.fetchCount();
  },
  data() {
    return {
      dialogFormVisible: false,
      selectedGroup: {},
      pageSize: 10,
      selectedPage: 1,
      selectedUser: {},
      deleteDialog: false,
      users: [],
      count: 0,
    };
  },
  methods: {
    async fetchPage() {
      try {
        this.users = await userService.get({
          filter: {
            limit: this.pageSize,
            skip: (this.selectedPage - 1) * this.pageSize,
            include: 'roles',
          },
        });

        for (let i in this.users) {
          this.users[i].name = this.users[i].firstname + " " + this.users[i].lastname;
          this.users[i].roles = this.users[i].roles[0]
        }
      } catch (e) {
        console.error(e);
      }
    },
    async fetchCount() {
      try {
        const count = await userService.countAll();
        this.count = count.count;
      } catch (e) {
        console.error(e);
      }
    },
    handlePageChange(page) {
      this.selectedPage = page;
      this.fetchPage();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.fetchPage();
    },
    confirmDelete(user) {
      this.selectedUser = user;
      this.deleteDialog = true;
    },
    async deleteSelectedUser() {
      this.deleteDialog = false;
      await userService.del(this.selectedUser);
      this.fetchPage();
      this.fetchCount();
    },
    navigate(data) {
      Vue.router.push(data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/user/view/index.js